import { useRecoilState } from "recoil";
import loaderStateAtom from "../atoms/loaderStateAtom";
import carListAtom from "../atoms/carListAtom";
import makeStateAtom from "../atoms/makeStateAtom";
import { useNavigate } from "react-router-dom";
import manualsAtom from "../atoms/manualsAtom";
import navHeaderAtom from "../atoms/navHeaderAtom";
import { useEffect } from "react";
import { containerOne } from "../utils/style";


function ModelSelector() {
    const [ carList, setCarList ] = useRecoilState(carListAtom);
    const [ showLoader, setShowLoader ] = useRecoilState(loaderStateAtom)
    const [ make, setMake ] = useRecoilState(makeStateAtom)
    const [ manual, setManual ] = useRecoilState(manualsAtom)
    const [ header, setHeader ] = useRecoilState(navHeaderAtom);

    const navigate = useNavigate()

    useEffect(() => {
        setHeader('Choose Your Model')
    }, [])

    function getModelList() {
        if(carList && make) {
            const models = [];
            carList.forEach(car => {
                if(car.make === make) {
                    models.push(car)
                }
            });
            return models;
        } else {
            return []
        }
    }

    function selectManualAndNavigate(manual) {
        try {
            setManual(manual)
            navigate('/manual')
        } catch (error) {
            console.log(error)
        }
    }


    return(
        <div className={containerOne}>
            <div className="">
                {
                    getModelList()?.map((car, i) => 
                    <div 
                        key={i} 
                        onClick={() => selectManualAndNavigate(car.manual)} 
                        className='p-4 rounded-lg shadow-lg mb-4 flex justify-between'
                    >
                        <div>
                            <img />
                            <div className="text-md font-semibold">{car.model}</div>
                        </div>
                        <div className="text-sm text-customOne font-semibold cursor-pointer">{`View PDF >`}</div>
                    </div>)
                }
            </div>
        </div>
    )
}

export default ModelSelector;

